import type { PeriodText } from '../../types/scheduleList.types'
import { DIM_TEXT_STYLE } from './listStyle'

// 기간 칸(D-05 ②) — `M/D ~ M/D` + 상태 줄(끝남 · 진행중 경과/n일 · n일 · 착공 D-n). 진행중만 강조색.
// 날짜 형식 오류로 기간을 만들 수 없는 행은 로직이 range·status 를 '-' 로 채워 보내며, 그대로 그린다.

export interface ScheduleListPeriodCellProps {
  period: PeriodText
}

export function ScheduleListPeriodCell({ period }: ScheduleListPeriodCellProps) {
  const running = period.state === 'running'
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-01)' }}>
      <span style={{ fontSize: 'var(--num-13, 13px)', color: 'var(--shell-on-surface)', whiteSpace: 'nowrap' }}>{period.range}</span>
      <span style={running ? { fontSize: 'var(--type-caption-size)', fontWeight: 600, color: 'var(--gt-primary)', whiteSpace: 'nowrap' } : { ...DIM_TEXT_STYLE, whiteSpace: 'nowrap' }}>
        {period.status}
      </span>
    </div>
  )
}
